import request from '../api.js';
import { getRestauranteIdSync, ensureRestauranteLoaded } from './selectedRestaurante';
import { TOTEMID } from '../constants';

/**
 * Serviço responsável por verificar a saúde dos métodos de pagamento
 */
export class HealthCheckService {
  static async checkPaymentMethods() { 
    try {
      let restauranteId = getRestauranteIdSync();
      if (!restauranteId) {
        const r = await ensureRestauranteLoaded();
        restauranteId = r?.ID || r?.id;
      }
      
      // Validar se restauranteId é válido antes de fazer a requisição
      if (!restauranteId || restauranteId === 'undefined' || restauranteId === 'null') {
        console.warn('RestauranteId não disponível para healthcheck, pulando verificação');
        return {
          success: false,
          error: 'Restaurante não identificado',
          data: {
            isHealthy: true, // Assumir que está saudável se não conseguir verificar
            message: 'Verificação pulada - restaurante não identificado',
            paymentMethods: {}
          }
        };
      }
      
      // Adicionar totemId como query parameter se disponível
      const totemId = TOTEMID ? parseInt(TOTEMID) : null;
      const url = totemId 
        ? `/payment/healthcheck/${restauranteId}?totemId=${totemId}`
        : `/payment/healthcheck/${restauranteId}`;
      
      console.log('Executando healthcheck:', { restauranteId, totemId, url });
      
      const response = await request.get(url);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Erro ao verificar healthcheck dos métodos de pagamento:', error);
      return {
        success: false,
        error: error.message,
        data: {
          isHealthy: false,
          message: 'Erro ao comunicar com o servidor',
          paymentMethods: {}
        }
      };
    }
  }

  /**
   * Verifica se há métodos de pagamento críticos offline
   * @param {Object} healthCheckResponse - Resposta do healthcheck
   * @returns {boolean} - True se há métodos críticos offline
   */
  static hasCriticalPaymentMethodsOffline(healthCheckResponse) {
    if (!healthCheckResponse || !healthCheckResponse.paymentMethods) {
      return true; // Se não conseguir verificar, assume que há problemas
    }

    // Métodos críticos que, se offline, colocam o totem em manutenção
    const criticalMethods = [
      'CARTAO CREDITO - STONE',
      'CARTAO DEBITO - STONE', 
      'VOUCHER - STONE'
    ];

    const offlineCriticalMethods = Object.entries(healthCheckResponse.paymentMethods)
      .filter(([methodName, methodData]) => 
        criticalMethods.includes(methodName) && !methodData.isAvailable
      );

    return offlineCriticalMethods.length > 0;
  }

  /**
   * Formata nome do método de pagamento para exibição
   * @param {string} methodName - Nome do método
   * @returns {string} - Nome formatado
   */
  static formatPaymentMethodName(methodName) {
    const methodNames = {
      'CARTAO CREDITO - STONE': 'Cartão de Crédito (Stone)',
      'CARTAO DEBITO - STONE': 'Cartão de Débito (Stone)',
      'VOUCHER - STONE': 'Voucher (Stone)',
      'PIX - MERCADOPAGO': 'PIX (MercadoPago)',
      'DINHEIRO': 'Dinheiro'
    };

    return methodNames[methodName] || methodName;
  }
}
